import {
  Component,
  OnInit,
  ElementRef,
  Input,
  Inject,
  Renderer2,
} from '@angular/core';
import * as Cesium from 'cesium';
import { Data } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { OPERATORS, RF_RADIUS } from 'src/app/services/constants';
import { Color } from 'cesium';
import { ApiService } from 'src/app/services/api.service';
import * as moment from 'moment';
import { CollectionPopupComponent } from '../collections/collection-popup/collection-popup.component';
import { PopupService } from 'src/app/services/popup.service';
var turf = require('@turf/turf');
var geoParse = require('wellknown');

const cesiumContainer = document.createElement('div');
cesiumContainer.id = 'cesiumGlobeContainer';
document.getElementsByTagName('body')[0].appendChild(cesiumContainer);
@Component({
  selector: 'app-previescreen',
  templateUrl: './previescreen.component.html',
  styleUrls: ['./previescreen.component.scss']
})
export class PreviescreenComponent implements OnInit {

  @Input() target: any = { geoJSON: '', area: 0 };
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  viewer: any = null;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  taskTarget: any;
  taskid: any;
  taskname: any;
  coordinates: any = [];
  observationCoordinates: any = [];
  observationCoordinatesDisplay: any = [];

  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  currentUser: any;
  taskMap: any;
  cesiumToken: any;
  sensors: any;
  targetPoints: any;
  dataLoading: boolean = true;
  observationLocation: any;
  observationType: any;
  cordinateLabel: string = 'Coordinates';
  constructor(

    private dialogRef: MatDialogRef<PreviescreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    private el: ElementRef, private renderer: Renderer2,
    private apiService: ApiService,
     private popupService: PopupService
  ) {
    this.cesiumToken = environment.cesiumAccessToken;
    if (data['type'] === 'taskPreview') {
    this.taskid = data['taskid'];
    this.taskname = data['taskname'];
    this.taskTarget = JSON.parse(this.data['target']);
    this.sensors = data['sensors'];
    this.targetPoints = this.data['targetPoints'] ? JSON.parse(this.data['targetPoints']) : null;
    this.observationLocation = this.data['observationLocation'];

    this.coordinates = [];
    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        this.coordinates = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
      } else if (this.taskTarget?.length > 1) {
        this.taskTarget.type = this.taskTarget[0].type;
        for (const points of this.taskTarget) {
          this.coordinates.push(points.coordinates)
        }
      } else {
        this.coordinates = this.taskTarget.coordinates;
      }
    }

    if (this.observationLocation) {
      let observationCoordinatesSplit = this.observationLocation.includes(';') ? this.observationLocation.split(';') : this.observationLocation;
      this.observationCoordinatesDisplay = observationCoordinatesSplit.toString().split(',').map(Number);
      this.observationCoordinates = this.observationLocation.split(';');
      if (this.observationCoordinates.length === 1) {
        this.observationType = 'Point';
      } else {
        this.observationType = 'Polygon';
      }
      this.cordinateLabel = 'Tipping Coordinates';
    }
  }

  ngOnInit(): void {
    var west = 40.0;
    var south = -20.0;
    var east = 120.0;
    var north = 70.0;

    var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
    Cesium.Ion.defaultAccessToken = this.cesiumToken;
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;

    const imageryViewModels: any = [];
    const terrainViewModels: any = [];

    //Bing Maps Aerial
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Aerial',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingAerial.png'
        ),
        tooltip: 'Bing Maps Aerial',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 2 });
        },
      })
    );

    //Sentinel data
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Sentinel-2',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/sentinel-2.png'
        ),
        tooltip: 'Sentinel-2 cloudless',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3954 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Road',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingRoads.png'
        ),
        tooltip: 'Bing Maps Road',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 4 });
        },
      })
    );
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Blue Marble',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/blueMarble.png'
        ),
        tooltip: 'Blue Marble Next Generation July, 2004 imagery from NASA.',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3845 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'OpenStreetMap',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/openStreetMap.png'
        ),
        tooltip: 'Open Street Map.',
        creationFunction: function () {
          return new Cesium.OpenStreetMapImageryProvider({
            url: 'https://a.tile.openstreetmap.org/',
          });
        },
      })
    );
    const worldTerrain = Cesium.createWorldTerrain({ requestWaterMask: false });
    terrainViewModels.push(worldTerrain);
    const viewer = new Cesium.Viewer('cesiumContainer', {
      imageryProviderViewModels: imageryViewModels,
      terrainProviderViewModels: [],
      // terrainProvider: worldTerrain,
      baseLayerPicker: true,
      geocoder: false,
      homeButton: true,
      fullscreenButton: false,
      selectionIndicator: true,
      shouldAnimate: false,
      animation: false,
      timeline: false,
      sceneModePicker: true,
      sceneMode: Cesium.SceneMode.SCENE2D,
    });
    this.viewer = viewer

    this.showLatLon(); 

    var target = this.target;

    this.scene = this.viewer.scene;
    if (!this.scene.pickPositionSupported) {
      window.alert('This browser does not support pickPosition.');
    }

    if (this.data['type'] === 'taskPreview') this.plotTarget();
    else if (this.data['type'] === 'permittedArea') {
      this.plotArea(this.data['user'].taskableAoi);
    } else if (this.data['type'] === 'satelliteTracking')  {
      this.dataLoading = true;
      this.getSatelliteData();
    }

    function zoomToLocation() {
      var entities = viewer.entities;
      var entityArray = entities.values;
      var myEntity = entityArray[0];

      if (myEntity) {
        var entities = viewer.entities;
        var entityArray = entities.values;
        var entity = entityArray[0];
        viewer.flyTo(entity);
      } else {
        var dataSourceCollection = viewer.dataSources;
        var dataSource = dataSourceCollection.get(0);

        if (dataSource) {
          viewer.flyTo(dataSource);
        }
      }
    }

    const homeButton = this.el.nativeElement.querySelector('.cesium-home-button');
           
    if (homeButton) {
      this.renderer.listen(homeButton, 'click', function () {        
        zoomToLocation();
      });
    }
  }

  plotTarget() {
    let target: any,
      viewer = this.viewer;
      const isLBandIncluded = this.sensors.some(item => (item.operatorKey === OPERATORS.LBAND));
      
    if (this.taskTarget) {
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
        var bbox = turf.bbox(this.taskTarget);
        var rectangle = Cesium.Rectangle.fromDegrees(
          bbox[0],
          bbox[1],
          bbox[2],
          bbox[3]
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          name: this.taskname,
          polygon: {
            hierarchy: {
              positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
            },
            fill: false,
            height: 0,
            outlineColor: Cesium.Color.YELLOW,
            outline: true,
          },
        });
        viewer.flyTo(target, { duration: 3 });
      } else if (this.taskTarget?.length > 1) {
        this.createGeoJSONFile(this.taskTarget);
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
        const lng = fpPos[0],
          lat = fpPos[1];
        var rectangle = Cesium.Rectangle.fromDegrees(
          lng - 1,
          lat - 1,
          lng + 1,
          lat + 1
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          id: this.taskname,
          position: Cesium.Cartesian3.fromDegrees(lng, lat), //  bbPosition,
          billboard: {
            image: 'assets/images/marker-icon.png',
            show: true, // default
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 20, // default: undefined
            height: 30, // default: undefined
          },
        });
        this.defaultLL = [lng, lat];
        this.viewer.camera.flyTo(
          {
            destination: Cesium.Cartesian3.fromDegrees(lng, lat, 100000.0),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90.0),
              roll: 0.0,
            },
          },
          { duration: 3 }
        );
      }
    }


    ///observatiom
    if (this.observationCoordinates?.length > 0) {
      if (this.observationType === 'Point') {
        const [lng, lat] = this.observationCoordinates[0].split(',').map(Number);

        viewer.entities.add({
          name: 'Observation Point',
          position: Cesium.Cartesian3.fromDegrees(lng, lat),
          point: {
            pixelSize: 10,
            color: Cesium.Color.RED,
          },
          label: {
            text: '',
            show: true, // default
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 10, // default: undefined
            height: 20, // default: undefined
          },
        });
      } else if (this.observationType === 'Polygon') {
        const coords = this.observationCoordinates
          .map(c => c.split(',').map(Number))
          .flat();

        viewer.entities.add({
          name: 'Observation Line',
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(coords),
            material: Cesium.Color.RED,
          },
        });
      }
    }
  }

  drawCircles(coordinates) {
    const radius = RF_RADIUS * 1000;
    const lng = coordinates[0],
      lat = coordinates[1];

      // Create a circle entity for each point
      this.viewer.entities.add({
        name:'circles',
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        ellipse: {
          semiMajorAxis: radius,
          semiMinorAxis: radius,
          material: Color.BLUE.withAlpha(0.4)
        },
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
  }

  createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };
  
  let selectData: any;
  selectData = Cesium.GeoJsonDataSource.load(geoJSON);

  selectData.then((dataSource) => {
    const entities = dataSource.entities.values;
    for (let i = 0; i < entities.length; i++) {
      const entity = entities[i];
      entity.billboard = new Cesium.BillboardGraphics({
        image: 'assets/images/marker-icon.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 30,
      });
      entity.label = new Cesium.LabelGraphics({
        text: (i + 1).toString(), // Set the label to the index + 1
        font: '14pt sans-serif',
        fillColor: Cesium.Color.WHITE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust the offset to position the label correctly
      });
    }

    this.viewer.flyTo(dataSource, { duration: 3 });
    this.viewer.dataSources.add(dataSource);
    this.viewer.scene.globe.depthTestAgainstTerrain = false;
  });
  }

  flyHome() {
    this.viewer.camera.flyHome(2); // take 2 seconds
  }

  showLatLon() {
    const viewer = this.viewer;
    const latlonOverlay = this.latlonOverlay;
    const scene = this.viewer.scene;
    const canvas = this.viewer.canvas;
    viewer.container.appendChild(latlonOverlay);
    latlonOverlay.style.position = 'absolute';
    latlonOverlay.style['z-index'] = '10';
    latlonOverlay.style.right = '3px';
    latlonOverlay.style.bottom = '88px';
    latlonOverlay.style.height = '30px';

    latlonOverlay.style.width = 'fit-content';
    latlonOverlay.style['pointer-events'] = 'none';
    latlonOverlay.style.textAlign = 'center';
    latlonOverlay.style.justifyContent = 'center';
    latlonOverlay.style.padding = '5px 4px 0 4px';
    latlonOverlay.style.color = 'rgba(255, 255, 255, 1)';
    latlonOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
    let mousePosition;
    const accuracy = 15;
    const handler = new Cesium.ScreenSpaceEventHandler(canvas);

    handler.setInputAction((movement) => {
      mousePosition = movement.endPosition;
      const cartesian = viewer.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid
      );
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

        const longString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(accuracy);
        const latString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(accuracy);
        const latitude = parseFloat(latString);
        const longitude = parseFloat(longString);

        const latitudeDMS = convertDecimalToDMS(latitude) + (latitude >= 0 ? 'N' : 'S');
        const longitudeDMS = convertDecimalToDMS(longitude) + (longitude >= 0 ? 'E' : 'W');

        function convertDecimalToDMS(decimal) {
          const degrees = Math.floor(Math.abs(decimal));
          const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
          const minutes = Math.floor(minutesDecimal);
          const seconds = (minutesDecimal - minutes) * 60;
                
          const formattedDegrees = degrees !== 0 ? `${degrees}°` : '';
          const formattedMinutes = minutes !== 0 ? `${minutes}'` : '';
          const formattedSeconds = `${seconds.toFixed(1)}"`;
        
          return `${formattedDegrees}${formattedMinutes}${formattedSeconds}`;
        }

        this.longLatStr = 'Lng: ' + longitudeDMS + ', ' + 'Lat: ' + latitudeDMS;

        latlonOverlay.innerHTML =
          "<div style='padding:0px'>" + this.longLatStr + '</div>';
      } else {
        this.longLatStr = '';
        latlonOverlay.innerHTML = "<div style='padding:0px'>Out of Globe</div>";
        // latlonOverlay.style.display = 'none';
      }
      this.roll = Cesium.Math.toDegrees(this.viewer.camera.heading).toFixed(0);
      if (this.roll > 359.5) this.roll = 0;
      // this.compassOverlay.style.transform = `rotate(${360-this.roll}deg)`;
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  onKeyPress(e: any, msg: string) {
    if (e.key === 'Enter') {
      this.onNoClick(msg);
    }
  }
  onNoClick(msg: any): void {
    this.dialogRef.close('Done');   
  }

  plotArea(taskableAoi) {
    let target: any,
      viewer = this.viewer;
    for (const file of taskableAoi) {
      this.taskTarget = file.taskableAoi;
      if (this.taskTarget) {
        if (this.taskTarget.type === 'Polygon') {
          const fpPos = this.taskTarget.coordinates[0]
            .toString()
            .split(',')
            .map(Number);
          var bbox = turf.bbox(this.taskTarget);
          var rectangle = Cesium.Rectangle.fromDegrees(
            bbox[0],
            bbox[1],
            bbox[2],
            bbox[3]
          );

          const coords = Cesium.Cartesian3.fromDegreesArray(fpPos);


         const polygonPoints = this.taskTarget.coordinates[0];
          // Step 2: Find the bottom-most point (minimum latitude)
          const bottomLonLat = polygonPoints.reduce((lowest, current) => {
            return current[1] < lowest[1] ? current : lowest;
          }, polygonPoints[0]);
      
          // Step 3: Calculate dynamic vertical shift
          const latitudes = polygonPoints.map(p => p[1]);
          const maxLat = Math.max(...latitudes);
          const minLat = Math.min(...latitudes);
          const latRange = maxLat - minLat;
      
          // Use 5% of the polygon's vertical height to shift the label down
          const shiftDegrees = latRange * 0.05;
          const labelLat = bottomLonLat[1] - shiftDegrees;
      
          // Step 4: Convert to Cesium Cartesian3
          const labelPosition = Cesium.Cartesian3.fromDegrees(bottomLonLat[0], labelLat);


          Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
          target = viewer.entities.add({
            name: file.fileName,
            polygon: {
              hierarchy: {
                positions: coords,
              },
              material: Cesium.Color.ORANGERED.withAlpha(0.1),
              fill: false,
              height: 0,
              outlineColor: Cesium.Color.YELLOW,
              outline: true,
            },
            position: labelPosition, // <-- this is where position belongs
            label: {
              text: file.fileName,
              font: '12pt sans-serif',
              fillColor: Cesium.Color.WHITE,
              style: Cesium.LabelStyle.FILL_AND_OUTLINE,
              outlineWidth: 2,
              outlineColor: Cesium.Color.BLACK,
              showBackground: true,
              backgroundColor: Cesium.Color.BLACK.withAlpha(0.5),
            }
          });
          viewer.flyTo(target, { duration: 3 });
        }
      }
    }
  }

 getSatelliteData() {
    let sensor = this.data['sensor'];
    let sensorName, sensorInfo;
    if (sensor?.key != OPERATORS.HEAD) {
      sensorName = [sensor?.name];
      sensorInfo = [{ key: sensor?.name, obfuscateName: sensor?.obfuscateName }];
    } else {
      sensorName = [sensor?.key];
      sensorInfo = [{ key: sensor?.key, obfuscateName: sensor?.obfuscateName }];
    }
    let sensorData = {};
    sensorData['sensorName'] = sensorName;
    sensorData['sensors'] = sensorInfo;
    sensorData['action'] = this.data['action'];

    if (this.data['action'] === 'projectedData') {
      let target = this.data['target'];
      sensorData['openWindow'] = moment(target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment(target.closeWindow)
        .utcOffset(0, true)
        .format();
      sensorData['target'] = JSON.stringify(geoParse(target.geoJSON));
    }

    const sensorObj = { sensorData: sensorData };
    this.apiService.getSatelliteData(sensorObj).subscribe((res: any) => {
      if (res?.msg === 'Failed') {
        this.dataLoading = false;
        const message = 'There are no active satellites for the chosen provider at this time. Please select another.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      } else this.plotSatellitePath(res);
    });
  }

  plotSatellitePath(result: any) {
    if (result?.length > 0) {
      for (let i = 0; i < result.length; i++) {
        let satelliteData = result[i];
        let orbitPosition: any = [];
        let satellite = satelliteData;
        orbitPosition.push(satellite.longitude, satellite.latitude, satellite.position[satellite.position.length - 1][0], satellite.position[satellite.position.length - 1][1]);

        let satelliteEntity = this.viewer.entities.add({
          name: 'orbit',
          position: Cesium.Cartesian3.fromDegrees(
            satellite.longitude,
            satellite.latitude,
          ),
          billboard: {
            image: 'assets/images/satellite.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 25,
            height: 20,
          },
          label: {
            text: ((this.data['user'].obfuscated && satellite.obfuscateName) ? satellite.obfuscateName : satellite.name) + '\n' + satellite.time,
            font: '11px Barlow',
            fillColor: Color.YELLOW,
            outlineColor: Color.YELLOW,
            outlineWidth: 1,
            style: 2,
            pixelOffset: new Cesium.Cartesian2(0, 10),
          },
          satellitesToRemove: true,
        });

        let randomColor = 'YELLOW';
        let key = this.data['sensor'].key;
        if (key === OPERATORS.CAPELLA) {
          randomColor = 'YELLOW';
        } else if (key === OPERATORS.SATELLOGIC) {
          randomColor = 'YELLOWGREEN';
        } else if (key === OPERATORS.UMBRA) {
          randomColor = 'BLUE';
        } else if (key === OPERATORS.HEAD) {
          randomColor = 'GREENYELLOW';
        } else if (key === OPERATORS.STE) {
          randomColor = 'BLUEVIOLET';
        } else if (key === OPERATORS.AT21) {
          randomColor = 'GREEN';
        } else if (key === OPERATORS.KOMPSAT) randomColor = 'CYAN';
        else if (key === OPERATORS.USL) randomColor = 'INDIGO'; 
        else if (key === OPERATORS.ISI) randomColor = 'TURQUOISE'; 
        else if (key === OPERATORS.AXELSPACE) randomColor = 'GOLD';
        else if (key === OPERATORS.GHG) randomColor = '#25aae0'; 
        else if (key === OPERATORS.ORORATECH) randomColor = '#008B8B'; 
        else if (key === OPERATORS.WYVERN) randomColor = 'Brown'; 
        else if (key === OPERATORS.SPIRE) randomColor = 'Plum'; 
        else if (key === OPERATORS.CLYDE) randomColor = '#BC8F8F'; 
        else if (key === OPERATORS.SYNSPECTIVE) randomColor = 'GREEN'; 
        else if (key === OPERATORS.GOKTURK) randomColor = '#9ce49c'; 
        else if (key === OPERATORS.LBAND) randomColor = 'Violet'; 
        else if (key === OPERATORS.ECURS || key === OPERATORS.ECURS_L) randomColor = 'Aqua'; 
        else if (key === OPERATORS.ESPER) randomColor = 'DeepPink'; 
        else randomColor = 'ROYALBLUE';

        // Render orbital path     
        let orbitalPath = this.viewer.entities.add({
          name: 'orbit',
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(orbitPosition),
            width: 5,
             material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.fromCssColorString(randomColor)
            )
          },
          satellitesToRemove: true
        });
        this.dataLoading = false;
        this.viewer.flyTo(this.viewer.entities); // Zoom to show the entire orbital path

      }
    }
  }
}
